import React from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

import useContent from '../../../components/hooks/useContent'
import ScrollTop from '../../../components/utils/ScrollTop'
import Header from '../../../components/landing/Header'
import LazyImage from '../../../components/display/LazyImage'
import MetaTags from '../../../components/meta/MetaTags'

import { SectionOuter } from '../section'

import TeamMemberCard from './TeamMemberCard'
import type { Member } from './types'

const TeamMemberGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
  max-width: 1300px;
  justify-content: space-evenly;

  padding: 8px;
  margin-top: 48px;

  ${media.lg`
    padding: 16px;
    margin-top: 72px;
  `}
`

const TeamMemberItem = styled.div`
  margin-bottom: 32px;
  width: 164px;
  padding: 0 8px;

  ${media.md`
    width: 304px;
    padding: 0 16px;
    margin-bottom: 56px;
  `}
`

type TeamContent = {
  team_members: Member[]
}

type TeamProps = {
  loading: boolean
  content: TeamContent
}

const headerSrc =
  'https://assets.riparide.com/team_page/header_x2_25-03-2022.jpg 1248w'

const headerSrcset = `
  https://assets.riparide.com/team_page/header_x1_25-03-2022.jpg 624w,
  https://assets.riparide.com/team_page/header_x2_25-03-2022.jpg 1248w,
  https://assets.riparide.com/team_page/header_x3_25-03-2022.jpg 1872w
`

export function TeamComponent({ loading, content }: TeamProps) {
  return (
    <>
      <MetaTags title="Meet the team" />
      <ScrollTop />

      <Header
        h2Text="Meet the team"
        h3Text="Riparide inspires people to find fulfilling moments in nature. We believe work should be an inspiring, fulfilling adventure too."
        cta={<></>}
      >
        <LazyImage
          data-src={headerSrc}
          data-srcset={headerSrcset}
          preload
          alt=""
        />
      </Header>

      <SectionOuter>
        {!loading && (
          <TeamMemberGrid>
            {content?.team_members.map(({ image, ...member }) => (
              <TeamMemberItem key={member.name}>
                <TeamMemberCard
                  {...member}
                  image={`https://assets.riparide.com/about_page/team_members/${image}`}
                />
              </TeamMemberItem>
            ))}
          </TeamMemberGrid>
        )}
      </SectionOuter>
    </>
  )
}

export default function Team() {
  const { loading, content } = useContent<TeamContent>('about_page')

  return <TeamComponent loading={loading} content={content} />
}
